export default "__VITE_ASSET__Dpb$wIsq__"